/**
 * CA helper for Pendo product management tracking
 * */

// Globals: pendo

const MEMBER_INFO_SESSION_KEY = 'memberInfo';
const accountId = window.location && window.location.host ? window.location.host.split('.')[0] : false;

export default class CaPendo {
  isUserLoggedIn;

  constructor() {
    this.isUserLoggedIn = false;
    if (document.cookie.split(';').some((item) => item.includes('isLoggedIn=1'))) {
      this.isUserLoggedIn = true;
    }
  }

  run() {
    this.getMemberInfo()
      .then((info) => {
        sessionStorage.setItem(MEMBER_INFO_SESSION_KEY, JSON.stringify(info));

        // Call pendo.initialize whenever information about your visitors becomes available.
        // Please use Strings, Numbers, or Bools for value types.
        const userId = info ? info.id : false;
        if (userId && accountId) {
          pendo.initialize({
            visitor: {
              id: [accountId, '_', userId].join(''), // Required if user is logged in, globally unique
              age: info.age,
              device: info.device,
              email: info.email,
              fullName: info.fullName,
              gender: info.gender,
              homeClub: info.homeclub,
              memberSince: info.membersince,
              roles: info.roles ? info.roles.join(', ') : '',
              staffGroups: info.staffGroups ? Object.values(info.staffGroups).join(', ') : '',
              status: info.status,
            },
            account: {
              id: accountId, // Account ID is our customer's subdomain
            },
          });
        }
      })
      .catch(() => {
        sessionStorage.removeItem(MEMBER_INFO_SESSION_KEY);
      });
  }

  getMemberInfo() {
    const deferred = new Promise((resolve, reject) => {
      if (!this.isUserLoggedIn) {
        reject(new Error('A user is not currently logged in'));
      }

      const cachedInfo = sessionStorage.getItem(MEMBER_INFO_SESSION_KEY);
      if (cachedInfo) {
        resolve(JSON.parse(cachedInfo));
      } else {
        fetch('/user/get-member-info')
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Network request for user info failed');
          })
          .then((data) => {
            resolve(data.info);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
    return deferred;
  }
}
